module.exports = __webpack_public_path__ + "static/media/shop.2f8b2df6.svg";